import { createBrowserRouter, Navigate } from "react-router-dom";
import { LandingPage } from "@/pages/LandingPage";
import { LoginPage } from "@/pages/LoginPage";
import { DashboardPage } from "@/pages/DashboardPage";
import { NewCasePage } from "@/pages/NewCasePage";
import { ChatGatingPage } from "@/pages/ChatGatingPage";
import { CaseDetailPage } from "@/pages/CaseDetailPage";
import { CaseWorkspacePage } from "@/pages/cases/CaseWorkspacePage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { TermsPage } from "@/pages/TermsPage";
import { PrivacyPage } from "@/pages/PrivacyPage";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { WizardLayout } from "@/components/WizardLayout";
import { AdminLayout } from "@/components/AdminLayout";
import { Step1Personal } from "@/pages/wizard/Step1Personal";
import { StepBiographic } from "@/pages/wizard/StepBiographic";
import { StepAddresses } from "@/pages/wizard/StepAddresses";
import { StepEmployment } from "@/pages/wizard/StepEmployment";
import { StepTravel } from "@/pages/wizard/StepTravel";
import { StepMarriage } from "@/pages/wizard/StepMarriage";
import { StepChildren } from "@/pages/wizard/StepChildren";
import { StepCriminal } from "@/pages/wizard/StepCriminal";
import { StepDocuments } from "@/pages/wizard/StepDocuments";
import { StepOath } from "@/pages/wizard/StepOath";
import { StepContact } from "@/pages/wizard/StepContact";
import { StepFeeReduction } from "@/pages/wizard/StepFeeReduction";
import { StepInterpreter } from "@/pages/wizard/StepInterpreter";
import { StepPreparer } from "@/pages/wizard/StepPreparer";
import { StepCheckout } from "@/pages/wizard/StepCheckout";
import { StepReview } from "@/pages/wizard/StepReview";
import { AdminLoginPage } from "@/pages/admin/AdminLoginPage";
import { AdminCasesPage } from "@/pages/admin/AdminCasesPage";
import { AdminCaseDetailPage } from "@/pages/admin/AdminCaseDetailPage";
import { AdminDocumentsPage } from "@/pages/admin/AdminDocumentsPage";

export const router = createBrowserRouter([
  { path: "/", element: <LandingPage /> },

  { path: "/login",   element: <LoginPage /> },
  { path: "/terms",   element: <ErrorBoundary><TermsPage /></ErrorBoundary> },
  { path: "/privacy", element: <ErrorBoundary><PrivacyPage /></ErrorBoundary> },

  // ── Admin ───────────────────────────────────────────────────────────────
  // Completely separate auth context from client app (Bearer token, not cookies).
  { path: "/admin/login", element: <AdminLoginPage /> },
  {
    path: "/admin",
    element: <AdminLayout />,
    children: [
      { index: true, element: <Navigate to="cases" replace /> },
      { path: "cases", element: <AdminCasesPage /> },
      { path: "cases/:id", element: <AdminCaseDetailPage /> },
      { path: "documents", element: <AdminDocumentsPage /> },
    ],
  },

  // ── Client app ──────────────────────────────────────────────────────────
  {
    element: <ErrorBoundary><ProtectedRoute /></ErrorBoundary>,
    children: [
      { path: "/dashboard", element: <DashboardPage /> },
      { path: "/cases/new", element: <NewCasePage /> },
      { path: "/cases/:id/gating", element: <ChatGatingPage /> },
      { path: "/cases/:id/workspace", element: <CaseWorkspacePage /> },
      { path: "/cases/:id", element: <CaseDetailPage /> },

      // Wizard — persistent sidebar + per-step content via Outlet.
      {
        path: "/cases/:id/wizard",
        element: <WizardLayout />,
        children: [
          { index: true, element: <Navigate to="personal" replace /> },
          { path: "personal", element: <Step1Personal /> },
          { path: "biographic", element: <StepBiographic /> },
          { path: "addresses", element: <StepAddresses /> },
          { path: "employment", element: <StepEmployment /> },
          { path: "travel", element: <StepTravel /> },
          { path: "marriage", element: <StepMarriage /> },
          { path: "children", element: <StepChildren /> },
          { path: "criminal", element: <StepCriminal /> },
          { path: "documents", element: <StepDocuments /> },
          { path: "oath", element: <StepOath /> },
          { path: "contact", element: <StepContact /> },
          { path: "fee-reduction", element: <StepFeeReduction /> },
          { path: "interpreter", element: <StepInterpreter /> },
          { path: "preparer", element: <StepPreparer /> },
          { path: "checkout", element: <StepCheckout /> },
          { path: "review", element: <StepReview /> },
        ],
      },
    ],
  },

  { path: "*", element: <NotFoundPage /> },
]);
